import * as v from '@badrap/valita'
import { api } from 'src/api'
import { encrypt } from 'src/utils/crypto'

export const logging = (
  params: {
    organization: string
    location: string
  } & (
    | {
        type: 'error'
        message: string
        stack: string
      }
    | {
        type: 'location'
      }
  ),
) =>
  api({
    schema: v.object({
      result: v.literal('OK'),
    }),
    method: 'POST',
    url: '/provisioning/logging',
    body: {
      ...params,
      check: encrypt(params.location),
    },
    withAuth: false,
  })
